import { render, staticRenderFns } from "./printPrescription.vue?vue&type=template&id=86c3f842&"
import script from "./printPrescription.vue?vue&type=script&lang=js&"
export * from "./printPrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports